import { HashRouter, Routes, Route } from "react-router-dom";
import Home from "./views/home";
import Demonlist from "./views/dl";
import Team from "./views/team";
import Roulette from "./views/roulette";
import Lists from "./views/lists";
import Challengelist from "./views/cl";
import Platformerlist from "./views/pl";
import Leaders from "./views/leaders";
import Header from "./components/Header";
import Footer from "./components/Footer";
import ScrollToTop from "./utils/scrollToTop";

export default function App() {
    return (
        <HashRouter>
            <ScrollToTop />
            <Header />
            <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/dl" element={<Demonlist />} />
                <Route path="/team" element={<Team />} />
                <Route path="/roulette" element={<Roulette />} />
                <Route path="/lists" element={<Lists />} />
                <Route path="/cl" element={<Challengelist />} />
                <Route path="/pl" element={<Platformerlist />} />
                <Route path="/leaders" element={<Leaders />} />
            </Routes>
            <Footer />
        </HashRouter>
    );
}